module.exports = __webpack_public_path__ + "media/fonts/Aleo-LightItalic-1b99a21d00583a5367769b4e493b7e48.ttf";